import { settingsConstants } from 'Constants';
import Request from 'Services/request';
import { toast as toastr } from 'react-toastify';
import { handleApiError } from 'Helpers/index';

export const settingActions = {
  updateSettings,
  fetchSettings
};

function fetchSettings() {

  return (dispatch) => {
    dispatch(request({}));
    Request.get('/settings', {})
      .then((response) => {
        const { data } = response;
        dispatch(success(data.shift()));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failure(error.toString()));
        }
      });
  };

  function request(settings) { return { type: settingsConstants.SETTINGS_REQUEST, settings }; }
  function success(settings) { return { type: settingsConstants.SETTINGS_GET_SUCCESS, settings }; }
  function failure(error) { return { type: settingsConstants.SETTINGS_FAILURE, error }; }
}

function updateSettings(settingObject) {
  return (dispatch) => {
    dispatch(request({}));
    Request.update(`/settings`,
      { ...settingObject })
      .then((response) => {
        const { message } = response;    
        dispatch(fetchSettings());
        toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failure(error.toString()));
        }
      });
  };

  function request(settings) { return { type: settingsConstants.SETTINGS_REQUEST, settings }; }
  function failure(error) { return { type: settingsConstants.SETTINGS_FAILURE, error }; }
}
